// src/pages/admin/Login.jsx
import { useEffect, useState } from "react";
import { Helmet } from "react-helmet-async";
import { useNavigate } from "react-router-dom";
import { useAuth } from "../../hooks/useAuth";
import { useBranding } from "../../hooks/useBranding";
import { withCloudinaryLogoOptimization } from "../../utils/cloudinary";
import { NilamLogo, B, fonts, Btn } from "../../components/UI";

export default function Login() {
  // const { admin, loading: authLoading, loginWithEmail, loginWithGoogle } = useAuth();
  const { admin, loading: authLoading, loginWithEmail } = useAuth();
  const { branding }  = useBranding();
  const navigate      = useNavigate();
  const [email,    setEmail]    = useState("");
  const [password, setPassword] = useState("");
  const [error,    setError]    = useState("");
  const [loading,  setLoading]  = useState(false);
  // const [gLoading, setGLoading] = useState(false);

  const accent = branding.primaryColor || B.orange;

  useEffect(() => {
    if (!authLoading && admin) navigate("/admin", { replace: true });
  }, [admin, authLoading, navigate]);

  const handleEmail = async () => {
    if (!email || !password) { setError("Please enter email and password."); return; }
    setLoading(true); setError("");
    try {
      await loginWithEmail(email, password);
      navigate("/admin");
    } catch (e) {
      setError(e.message || "Login failed. Please try again.");
    } finally { setLoading(false); }
  };

  // const handleGoogle = async () => {
  //   setGLoading(true); setError("");
  //   try {
  //     const result = await loginWithGoogle();
  //     if (!result?.redirected) navigate("/admin");
  //   } catch (e) {
  //     setError(e.message || "Google sign-in failed.");
  //   } finally { setGLoading(false); }
  // };

  return (
    <>
      <Helmet>
        <title>Admin Login — {branding.brandName}</title>
        <meta name="robots" content="noindex, nofollow" />
      </Helmet>

      <div style={{ minHeight: "100vh", display: "flex", alignItems: "center", justifyContent: "center", background: `linear-gradient(135deg, ${B.headerBg} 0%, #3D1A00 100%)`, padding: 20 }}>
        <div style={{ width: "100%", maxWidth: 420 }}>

          {/* Card */}
          <div style={{ background: B.white, borderRadius: 20, overflow: "hidden", boxShadow: "0 32px 80px rgba(0,0,0,0.4)" }}>

            {/* Header */}
            <div style={{ background: B.headerBg, padding: "32px 32px 28px", textAlign: "center", borderBottom: `3px solid ${accent}` }}>
              <NilamLogo size={56} logoUrl={withCloudinaryLogoOptimization(branding.logoUrl)} />
              <div style={{ fontFamily: fonts.adminDisplay, fontSize: 22, fontWeight: 700, color: accent, marginTop: 14 }}>
                Admin Portal
              </div>
              <div style={{ fontFamily: fonts.body, fontSize: 12, color: "rgba(255,255,255,0.4)", marginTop: 4 }}>
                {branding.brandName}
              </div>
            </div>

            {/* Form */}
            <div style={{ padding: "32px 32px 28px" }}>
              <div style={{ background: B.orangeFaint, border: `1px solid ${B.orangeMid}`, borderRadius: 8, padding: "10px 12px", marginBottom: 18, fontSize: 12, color: B.textMid, fontFamily: fonts.body }}>
                Sign-in is restricted to admin accounts created by a Super Admin.
              </div>

              {/* Google Sign-In */}
              {/* <button onClick={handleGoogle} disabled={gLoading}
                style={{ width: "100%", display: "flex", alignItems: "center", justifyContent: "center", gap: 12, background: B.white, border: `1.5px solid ${B.border}`, borderRadius: 10, padding: "12px 20px", cursor: gLoading ? "not-allowed" : "pointer", fontSize: 14, fontWeight: 600, color: B.text, fontFamily: fonts.body, marginBottom: 20, transition: "all 0.2s", opacity: gLoading ? 0.6 : 1 }}
                onMouseEnter={e => e.currentTarget.style.background = B.orangeFaint}
                onMouseLeave={e => e.currentTarget.style.background = B.white}
              > */}
                {/* Google icon */}
                {/* <svg width="20" height="20" viewBox="0 0 48 48">
                  <path fill="#FFC107" d="M43.6 20H24v8h11.3C33.7 33.1 29.3 36 24 36c-6.6 0-12-5.4-12-12s5.4-12 12-12c3.1 0 5.8 1.1 7.9 3l5.7-5.7C34.1 6.5 29.3 4 24 4 12.9 4 4 12.9 4 24s8.9 20 20 20c11 0 19.6-8 19.6-20 0-1.3-.1-2.7-.4-4z"/>
                  <path fill="#FF3D00" d="M6.3 14.7l6.6 4.8C14.5 16 19 13 24 13c3.1 0 5.8 1.1 7.9 3l5.7-5.7C34.1 6.5 29.3 4 24 4c-7.7 0-14.3 4.4-17.7 10.7z"/>
                  <path fill="#4CAF50" d="M24 44c5.2 0 9.9-1.9 13.5-5l-6.2-5.2C29.4 35.6 26.8 36.5 24 36.5c-5.2 0-9.7-3-11.4-7.2l-6.6 5.1C9.8 39.7 16.4 44 24 44z"/>
                  <path fill="#1976D2" d="M43.6 20H24v8h11.3c-.8 2.3-2.3 4.2-4.2 5.6l6.2 5.2C41 35.8 44 30.3 44 24c0-1.3-.1-2.7-.4-4z"/>
                </svg>
                {gLoading ? "Signing in..." : "Continue with Google"}
              </button> */}

              {/* Divider */}
              {/* <div style={{ display: "flex", alignItems: "center", gap: 12, marginBottom: 20 }}>
                <div style={{ flex: 1, height: 1, background: B.borderLight }} />
                <span style={{ fontSize: 11, color: B.textLight, fontFamily: fonts.body, letterSpacing: "0.08em" }}>OR</span>
                <div style={{ flex: 1, height: 1, background: B.borderLight }} />
              </div> */}

              {/* Email fields */}
              <div style={{ marginBottom: 14 }}>
                <label style={{ display: "block", fontSize: 10, fontWeight: 600, color: B.textMid, marginBottom: 6, letterSpacing: "0.1em", textTransform: "uppercase", fontFamily: fonts.body }}>Email</label>
                <input
                  type="email" value={email} onChange={e => { setEmail(e.target.value); setError(""); }}
                  onKeyDown={e => e.key === "Enter" && handleEmail()}
                  placeholder="admin@nilamsynthetics.com"
                  style={{ width: "100%", background: B.white, border: `1.5px solid ${B.border}`, borderRadius: 8, padding: "11px 14px", fontSize: 14, color: B.text, fontFamily: fonts.body, outline: "none", boxSizing: "border-box" }}
                  onFocus={e => e.target.style.borderColor = accent}
                  onBlur={e  => e.target.style.borderColor = B.border}
                />
              </div>
              <div style={{ marginBottom: 20 }}>
                <label style={{ display: "block", fontSize: 10, fontWeight: 600, color: B.textMid, marginBottom: 6, letterSpacing: "0.1em", textTransform: "uppercase", fontFamily: fonts.body }}>Password</label>
                <input
                  type="password" value={password} onChange={e => { setPassword(e.target.value); setError(""); }}
                  onKeyDown={e => e.key === "Enter" && handleEmail()}
                  placeholder="••••••••"
                  style={{ width: "100%", background: B.white, border: `1.5px solid ${B.border}`, borderRadius: 8, padding: "11px 14px", fontSize: 14, color: B.text, fontFamily: fonts.body, outline: "none", boxSizing: "border-box" }}
                  onFocus={e => e.target.style.borderColor = accent}
                  onBlur={e  => e.target.style.borderColor = B.border}
                />
              </div>

              {error && (
                <div style={{ background: B.redLight, border: `1px solid ${B.red}33`, borderRadius: 8, padding: "10px 14px", marginBottom: 16, fontSize: 13, color: B.red, fontFamily: fonts.body }}>
                  {error}
                </div>
              )}

              <button onClick={handleEmail} disabled={loading}
                style={{ width: "100%", background: loading ? B.orangeMid : accent, color: "#fff", border: "none", borderRadius: 10, padding: "13px", fontSize: 14, fontWeight: 700, cursor: loading ? "not-allowed" : "pointer", fontFamily: fonts.body, transition: "background 0.2s" }}>
                {loading ? "Signing in..." : "Sign In"}
              </button>

              <div style={{ textAlign: "center", marginTop: 20 }}>
                <span onClick={() => navigate("/")}
                  style={{ fontSize: 12, color: B.textLight, cursor: "pointer", fontFamily: fonts.body }}>
                  ← Back to Catalog
                </span>
              </div>
            </div>
          </div>

          <p style={{ textAlign: "center", fontSize: 11, color: "rgba(255,255,255,0.2)", marginTop: 20, fontFamily: fonts.body }}>
            This page is not publicly linked. Bookmark it and keep it private.
          </p>
        </div>
      </div>
    </>
  );
}
